import { Box, Grid, Typography } from '@mui/material';
import { colors } from '../styles/fontStyles';
import { styled } from '@mui/material/styles';
import OrderCheckoutStepperWrapper from './OrderCheckoutStepperWrapper';
import OrderCheckoutProductImage from './OrderCheckoutProductImage';
import { useThemeContext } from '../contexts/BaseThemeContextProvider';

const GridDeliveryFormContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    alignItems: 'left',
    flexDirection: 'column',
    textAlign: 'left',
  },
}));

type OrderCheckoutAddressContainerProps = {
  children: React.ReactNode;
  handleBack: () => void;
  activeStep: number;
};

export default function OrderCheckoutAddressContainer({
  handleBack,
  activeStep,
  children,
}: OrderCheckoutAddressContainerProps) {
  const { theme } = useThemeContext();
  return (
    <>
      <OrderCheckoutStepperWrapper handleBack={handleBack} activeStep={activeStep} />
      <GridDeliveryFormContainer container spacing={2}>
        <OrderCheckoutProductImage />
        <Grid item xs={12} sm={12} md={7} style={{ paddingLeft: '33px' }}>
          <Typography gutterBottom sx={{ typography: { sm: 'h5', md: 'h3' }, display: { xs: 'none', md: 'flex' } }}>
            Buy home PFAS test
          </Typography>
          <Box
            sx={{ display: 'flex', justifyContent: 'flex-start', width: '100%' }}
          >
            <Typography
              variant="h5"
              sx={{
                mt: 1,
                mb: 3,
                background: theme.custom.orderPFAS.subheader.background,
                color: theme.custom.orderPFAS.subheader.color,
                width: 'fit-content',
              }}
              gutterBottom
            >
              Where should we send the test kit?
            </Typography>
          </Box>
          {children}
        </Grid>
      </GridDeliveryFormContainer>
    </>
  );
}
